// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppearanceSettingsPopup__container-dae768 {
  overflow-y: auto;
  overflow-x: hidden;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/AppearanceSettingsPopup/AppearanceSettingsPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,kBAAA;AACF","sourcesContent":[".container {\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AppearanceSettingsPopup__container-dae768`
};
module.exports = ___CSS_LOADER_EXPORT___;
